import React from "react";
import Page from "@jumbo/shared/Page";
import TenantAdminRoute from "../../routes/TenantAdminRoute";
import ActiveClients from "./ActiveClients";
import AddClient from "./AddClient";
import Favorites from "./Favorites";
import InactiveClients from "./InactiveClient";
import TrackChanges from "./TrackChanges/TrackChanges";
import ClientChanges from "./TrackChanges/ClientChanges";

// Reports
import InventorDetailsReport from "./Reports/InventorDetailsReport";
import LicensingSummaryReport from "./Reports/LicensingSummaryReport";
import EntityStatusReport from "./Reports/EntityStatusReport";

const KotRoutes = [
  {
    path: ["/kot", "/kot/active-clients"],
    element: <TenantAdminRoute element={<Page component={ActiveClients} />} />,
  },
  {
    path: ["/kot/favorites"],
    element: <TenantAdminRoute element={<Page component={Favorites} />} />,
  },
  {
    path: ["/kot/track-changes"],
    element: <TenantAdminRoute element={<Page component={TrackChanges} />} />,
  },
  {
    path: ["/kot/track-changes/:clientId"],
    element: <TenantAdminRoute element={<Page component={ClientChanges} />} />,
  },
  {
    path: "/kot/client/new/*",
    element: <TenantAdminRoute element={<Page component={AddClient} />} />,
  },
  {
    path: "/kot/client/edit/:clientId/*",
    element: <TenantAdminRoute element={<Page component={AddClient} />} />,
  },
  {
    path: "/kot/inactive-clients",
    element: <TenantAdminRoute element={<Page component={InactiveClients} />} />,
  },
  {
    path: "/kot/reports/inventor-details",
    element: <TenantAdminRoute element={<Page component={InventorDetailsReport} />} />,
  },
  {
    path: "/kot/reports/licensing-summary",
    element: <TenantAdminRoute element={<Page component={LicensingSummaryReport} />} />,
  },
  {
    path: "/kot/reports/entity-status",
    element: <TenantAdminRoute element={<Page component={EntityStatusReport} />} />,
  },
];

export default KotRoutes;
